export default function Footer() {
  return (
    <footer
      id="footer"
      className="relative bg-ink text-white-t"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1200px] px-5 md:px-8 pt-16 md:pt-24 pb-8 md:pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-6">
            <div className="text-[11px] md:text-[12px] uppercase tracking-[0.18em] text-white-t/70 font-semibold">
              An education platform · Est. 2025
            </div>
            <h3 className="mt-5 md:mt-6 font-display text-3xl sm:text-4xl md:text-5xl leading-[1.05] tracking-tight max-w-[16ch]">
              One platform for{" "}
              <span className="font-italic-serif text-accent">
                schools, teachers and students.
              </span>
            </h3>
          </div>
          <div className="md:col-span-3">
            <div className="text-[11px] md:text-[12px] uppercase tracking-[0.14em] text-white-t/60 font-semibold mb-4">
              Platform
            </div>
            <ul className="space-y-2.5 text-[14px] md:text-[15px]">
              <li><a href="#benefits" className="link-underline">Modules</a></li>
              <li><a href="#compare" className="link-underline">Compare</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="text-[11px] md:text-[12px] uppercase tracking-[0.14em] text-white-t/60 font-semibold mb-4">
              Contact
            </div>
            <ul className="space-y-2.5 text-[14px] md:text-[15px]">
              <li>
                <a
                  href="mailto:hello@probodh.com"
                  className="link-underline"
                  data-testid="footer-email"
                >
                  hello@probodh.com
                </a>
              </li>
              <li>
                <a href="#contact" className="link-underline">
                  Book a walk-through
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Big wordmark */}
        <div className="mt-14 md:mt-20 select-none">
          <div className="font-display text-[22vw] md:text-[18vw] leading-[0.85] tracking-tight">
            ProBodh<span className="text-accent">.</span>
          </div>
        </div>

        <div className="mt-8 md:mt-10 pt-6 border-t border-white-t/10 flex flex-wrap items-center justify-between gap-3">
          <div className="text-[11px] md:text-[12px] uppercase tracking-[0.14em] text-white-t/60 font-semibold">
            © 2026 ProBodh · All rights reserved
          </div>
          <div className="text-[11px] md:text-[12px] uppercase tracking-[0.14em] text-white-t/60 font-semibold">
            Traditional values · Modernised approach
          </div>
        </div>
      </div>
    </footer>
  );
}
